<main class="tenders-list-page container">
  <h1 class="tenders-list-page__header">
    {{ 'global.tenders' | translate }}
  </h1>

  <div class="tenders-list-page__content">
    @if (filtersSheetOpen()) {
      <button
        type="button"
        class="tenders-list-page__backdrop"
        (click)="closeFiltersSheet()"
        [attr.aria-label]="'global.close' | translate"></button>
    }

    <aside
      class="tenders-list-page__filters"
      [class.tenders-list-page__filters--sheet]="filtersSheetOpen()">
      <div class="tenders-list-page__sheet-head">
        <h2 class="tenders-list-page__sheet-title">
          {{ 'solutions.filters.toggle' | translate }}
        </h2>
        <button
          type="button"
          class="tenders-list-page__sheet-close"
          (click)="closeFiltersSheet()"
          [attr.aria-label]="'global.close' | translate">
          <i class="iconsax" icon-name="x"></i>
        </button>
      </div>
      <div class="tenders-list-page__sheet-body">
        <pwj-filters-panel titleKey="solutions.filters.toggle" icon="filter-search">
          <pwj-products-filters></pwj-products-filters>
        </pwj-filters-panel>
      </div>
    </aside>

    <div class="tenders-list-page__main">
      @if (!isLoading) {
        <pwj-sorts-bar
          class="tenders-list-page__sort-bar"
          variant="segmented"
          [sorts]="filters"
          translateKey="enums.tenderStatus."
          [haveInitializeTab]="false"
          [resultsCount]="allTendersCount"
          [showFiltersButton]="showFiltersTriggerOnSortBar()"
          (filtersClick)="onFiltersFromSortBar()"></pwj-sorts-bar>
      } @else {
        <div class="tenders-list-page__sort-bar-skeleton" aria-hidden="true">
          <div class="tenders-list-page__sort-bar-skeleton-inner">
            <ngx-skeleton-loader
              count="1"
              class="tenders-list-page__sort-bar-skeleton-tabs"
              [theme]="{
                width: '100%',
                height: '2.375rem',
                'border-radius': '0.5rem',
                margin: '0',
              }"></ngx-skeleton-loader>
            <div class="tenders-list-page__sort-bar-skeleton-meta">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  width: '4.5rem',
                  height: '0.875rem',
                  'border-radius': '0.25rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
              @if (showFiltersTriggerOnSortBar()) {
                <ngx-skeleton-loader
                  count="1"
                  [theme]="{
                    width: '2.125rem',
                    height: '2.125rem',
                    'border-radius': '0.5rem',
                    margin: '0',
                  }"></ngx-skeleton-loader>
              }
            </div>
          </div>
        </div>
      }

      <div class="tenders-list-page__cards">
        @if (!isLoading) {
          @if (tendersData.length > 0) {
            <ul class="cards-list">
              @for (tender of tendersData; track tender._id) {
                <li class="cards-list__item">
                  <pwj-tender-card [data]="tender"></pwj-tender-card>
                </li>
              }
            </ul>
          } @else {
            <pwj-no-content message="tenders.noTenders"></pwj-no-content>
          }
        } @else if (isLoading) {
          <ul class="cards-list">
            <pwj-tender-card-skeleton [count]="6" [wrapInListItem]="true" />
          </ul>
        }
      </div>

      @if (allTendersCount && allTendersCount > 6) {
        <div>
          <pwj-pagination
            [dataCount]="allTendersCount"
            [perPage]="6"></pwj-pagination>
        </div>
      }
    </div>
  </div>
</main>
